import { Observable } from 'rxjs';
import { BaseCondition } from './base.condition';
import { NotificationService } from '../../services';

export class TimeSpentCondition extends BaseCondition {
    constructor(options: any, notificationService: NotificationService) {
        super("TimeSpentCondition", notificationService);
        this.observable = new Observable(observer => {
            // resolve to true in N seconds
            const timer = setTimeout(() => observer.next(true), options.AtLeast * 1000);

            // teardown logic
            return () => clearTimeout(timer);
        });
    }
}
